import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { signal } from '@angular/core';

export abstract class BaseRecordStrategy {
  recordedData = signal<Blob | null>(null);
  recordDataUrl = signal<SafeUrl | string | null>(null);

  constructor(protected readonly sanitizer: DomSanitizer) { }

  protected setRecordedBlob(blob: Blob, sanitize = false): void {
    const url = URL.createObjectURL(blob);
    const recordDataUrl = sanitize
      ? this.sanitizer.bypassSecurityTrustResourceUrl(url)
      : url;

    this.revokeUrl();

    this.recordedData.set(blob);
    this.recordDataUrl.set(recordDataUrl);
  }

  protected resetRecordedData(): void {
    this.revokeUrl();

    this.recordedData.set(null);
    this.recordDataUrl.set(null);
  }

  private revokeUrl(): void {
    const prevUrl = this.recordDataUrl();
    if (prevUrl && typeof prevUrl === 'string') {
      URL.revokeObjectURL(prevUrl);
    }
  }
}
